var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 527.924,
    height: 514.366,
    viewBox: "0 0 527.924 514.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_720",
    "data-name": "Rect\\xE1ngulo 720",
    width: 356.389,
    height: 248.303,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_765",
    "data-name": "Grupo 765",
    transform: "translate(-1188.661 -4438.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_758",
    "data-name": "Grupo 758",
    transform: "translate(1188.661 4553.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_346",
    "data-name": "Grupo 346",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_682",
    "data-name": "Rect\\xE1ngulo 682",
    width: 227.514,
    height: 77.487,
    rx: 38.743,
    fill: "#ffc0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_324",
    "data-name": "Trazado 324",
    d: "M2583.451-2894v63.045l-71.312-44.4Z",
    transform: "translate(-2355.937 2932.743)",
    fill: "#ffc0d4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1385",
    "data-name": "Trazado 1385",
    d: "M86.7,20.64,90.983,38h3.56l6.84-27.28h-3.4l-4.2,17.56q-.2.84-.5,2.3t-.54,3.06h-.16q-.2-1.24-.42-2.46t-.66-2.94l-4.28-17.52h-3.28l-4.28,17.24q-.4,1.6-.62,3t-.46,2.68h-.16q-.12-.64-.22-1.18t-.24-1.12q-.14-.58-.32-1.3t-.42-1.72l-4.48-17.6h-3.4L76.783,38H80.1l4.24-17.48q.24-.96.4-1.7t.28-1.38q.12-.64.22-1.26t.22-1.34h.16q.08.72.18,1.38t.22,1.32q.12.66.28,1.42T86.7,20.64ZM104.783,9.2V38h3.16V27.76a7.3,7.3,0,0,1,1.52-5.04,5.279,5.279,0,0,1,4.12-1.68,4.434,4.434,0,0,1,3.58,1.54,6.672,6.672,0,0,1,1.3,4.42V38h3.16V26.84a10.572,10.572,0,0,0-.7-4.1,7.566,7.566,0,0,0-1.78-2.66,6.532,6.532,0,0,0-2.42-1.44,8.488,8.488,0,0,0-2.66-.44,7.952,7.952,0,0,0-3.12.66,7.569,7.569,0,0,0-2.92,2.38h-.08V9.2Zm25.8,38.2,10.56-28.56h-3.2l-4,11.16q-.36,1.04-.68,2.02t-.64,2.02h-.08q-.08-.4-.24-.94t-.34-1.12q-.18-.58-.38-1.1t-.32-.88l-4.04-11.16h-3.24L131.023,38l-3.48,9.4Zm23.16-22.28q.68-.68,1.42-1.48a13.417,13.417,0,0,0,1.38-1.78,9.409,9.409,0,0,0,1.04-2.18,8.308,8.308,0,0,0,.4-2.64,7.458,7.458,0,0,0-.5-2.7,6.678,6.678,0,0,0-1.48-2.3,7.115,7.115,0,0,0-2.48-1.6,9.386,9.386,0,0,0-3.5-.6,8.854,8.854,0,0,0-3.16.56,7.819,7.819,0,0,0-2.58,1.58,7.421,7.421,0,0,0-1.74,2.46,8.17,8.17,0,0,0-.68,3.16h3.48a5.4,5.4,0,0,1,.36-2.02,4.46,4.46,0,0,1,.98-1.52,4.111,4.111,0,0,1,1.46-.94,4.9,4.9,0,0,1,1.76-.32,5.093,5.093,0,0,1,1.98.36,4.328,4.328,0,0,1,1.46.98,4.045,4.045,0,0,1,.9,1.44,5.143,5.143,0,0,1,.3,1.78,4.784,4.784,0,0,1-.28,1.7,6.753,6.753,0,0,1-.78,1.46,12.591,12.591,0,0,1-1.2,1.46q-.7.74-1.54,1.7a9.409,9.409,0,0,0-1.16,1.56,7.439,7.439,0,0,0-.68,1.54,8.159,8.159,0,0,0-.32,1.68q-.08.9-.08,1.98h2.92a9.141,9.141,0,0,1,.12-1.54,5.757,5.757,0,0,1,.4-1.34,5.985,5.985,0,0,1,.72-1.22A12.058,12.058,0,0,1,153.743,25.12Zm-5.56,9.36V38h3.52V34.48Z",
    transform: "translate(0 13.38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_759",
    "data-name": "Grupo 759",
    transform: "translate(1415.475 4439.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_347",
    "data-name": "Grupo 347",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_1",
    "data-name": "Uni\\xF3n 1",
    d: "M0,38.054A38.053,38.053,0,0,1,38.054,0H204.472a38.053,38.053,0,0,1,0,76.107H38.054q-.723,0-1.441-.027L0,99.976Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1383",
    "data-name": "Trazado 1383",
    d: "M76.5,20.64,80.78,38h3.56l6.84-27.28h-3.4l-4.2,17.56q-.2.84-.5,2.3t-.54,3.06h-.16q-.2-1.24-.42-2.46t-.66-2.94L77.02,10.72H73.74L69.46,27.96q-.4,1.6-.62,3t-.46,2.68h-.16Q68.1,33,68,32.46t-.24-1.12q-.14-.58-.32-1.3t-.42-1.72l-4.48-17.6h-3.4L66.58,38H69.9l4.24-17.48q.24-.96.4-1.7t.28-1.38q.12-.64.22-1.26t.22-1.34h.16q.08.72.18,1.38t.22,1.32q.12.66.28,1.42T76.5,20.64ZM94.58,9.2V38h3.16V27.76a7.3,7.3,0,0,1,1.52-5.04,5.279,5.279,0,0,1,4.12-1.68,4.434,4.434,0,0,1,3.58,1.54,6.672,6.672,0,0,1,1.3,4.42V38h3.16V26.84a10.572,10.572,0,0,0-.7-4.1,7.566,7.566,0,0,0-1.78-2.66,6.532,6.532,0,0,0-2.42-1.44,8.488,8.488,0,0,0-2.66-.44,7.952,7.952,0,0,0-3.12.66,7.569,7.569,0,0,0-2.92,2.38h-.08V9.2Zm20.6,19.2a10.436,10.436,0,0,0,.78,4.04,9.945,9.945,0,0,0,2.16,3.26,10.272,10.272,0,0,0,7.3,2.98,10.093,10.093,0,0,0,4.08-.82,10.317,10.317,0,0,0,3.26-2.22,9.961,9.961,0,0,0,2.14-3.26,10.42,10.42,0,0,0,.76-3.98,10.677,10.677,0,0,0-.76-4.04,9.624,9.624,0,0,0-2.12-3.24,9.878,9.878,0,0,0-3.24-2.14,11.195,11.195,0,0,0-8.16-.02,9.845,9.845,0,0,0-3.26,2.12,9.722,9.722,0,0,0-2.16,3.24A10.541,10.541,0,0,0,115.18,28.4Zm3.28,0a8.061,8.061,0,0,1,.52-2.94,7.1,7.1,0,0,1,1.44-2.32,6.618,6.618,0,0,1,2.2-1.54,7.311,7.311,0,0,1,5.66.02,6.456,6.456,0,0,1,2.2,1.58,7.243,7.243,0,0,1,1.4,2.34,8.444,8.444,0,0,1-.02,5.78,7.289,7.289,0,0,1-1.44,2.36,6.483,6.483,0,0,1-2.2,1.56,6.909,6.909,0,0,1-2.8.56,6.713,6.713,0,0,1-4.88-2.08,7.541,7.541,0,0,1-1.52-2.34A7.657,7.657,0,0,1,118.46,28.4Zm31.16-3.28q.68-.68,1.42-1.48a13.417,13.417,0,0,0,1.38-1.78,9.409,9.409,0,0,0,1.04-2.18,8.308,8.308,0,0,0,.4-2.64,7.458,7.458,0,0,0-.5-2.7,6.678,6.678,0,0,0-1.48-2.3,7.115,7.115,0,0,0-2.48-1.6,9.386,9.386,0,0,0-3.5-.6,8.854,8.854,0,0,0-3.16.56,7.819,7.819,0,0,0-2.58,1.58,7.421,7.421,0,0,0-1.74,2.46,8.17,8.17,0,0,0-.68,3.16h3.48a5.4,5.4,0,0,1,.36-2.02,4.46,4.46,0,0,1,.98-1.52,4.111,4.111,0,0,1,1.46-.94,4.9,4.9,0,0,1,1.76-.32,5.093,5.093,0,0,1,1.98.36,4.328,4.328,0,0,1,1.46.98,4.045,4.045,0,0,1,.9,1.44,5.143,5.143,0,0,1,.3,1.78,4.784,4.784,0,0,1-.28,1.7,6.753,6.753,0,0,1-.78,1.46,12.591,12.591,0,0,1-1.2,1.46q-.7.74-1.54,1.7a9.409,9.409,0,0,0-1.16,1.56,7.439,7.439,0,0,0-.68,1.54,8.159,8.159,0,0,0-.32,1.68q-.08.9-.08,1.98h2.92a9.141,9.141,0,0,1,.12-1.54,5.757,5.757,0,0,1,.4-1.34,5.985,5.985,0,0,1,.72-1.22A12.058,12.058,0,0,1,149.62,25.12Zm-5.56,9.36V38h3.52V34.48Z",
    transform: "translate(16.992 14.19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_760",
    "data-name": "Grupo 760",
    transform: "translate(1471.743 4595.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_348",
    "data-name": "Grupo 348",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_682-2",
    "data-name": "Rect\\xE1ngulo 682",
    width: 244.842,
    height: 72.603,
    rx: 36.302,
    transform: "translate(0)",
    fill: "#ff3900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_324-2",
    "data-name": "Trazado 324",
    d: "M2512.138-2894v59.071l66.818-41.6Z",
    transform: "translate(-2512.138 2930.302)",
    fill: "#ff3900"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1384",
    "data-name": "Trazado 1384",
    d: "M82.1,20.64,86.381,38h3.56l6.84-27.28h-3.4l-4.2,17.56q-.2.84-.5,2.3t-.54,3.06h-.16q-.2-1.24-.42-2.46t-.66-2.94l-4.28-17.52h-3.28l-4.28,17.24q-.4,1.6-.62,3t-.46,2.68h-.16q-.12-.64-.22-1.18t-.24-1.12q-.14-.58-.32-1.3t-.42-1.72l-4.48-17.6h-3.4L72.181,38H75.5l4.24-17.48q.24-.96.4-1.7t.28-1.38q.12-.64.22-1.26t.22-1.34h.16q.08.72.18,1.38t.22,1.32q.12.66.28,1.42T82.1,20.64ZM100.181,9.2V38h3.16V27.76a7.3,7.3,0,0,1,1.52-5.04,5.279,5.279,0,0,1,4.12-1.68,4.434,4.434,0,0,1,3.58,1.54,6.672,6.672,0,0,1,1.3,4.42V38h3.16V26.84a10.572,10.572,0,0,0-.7-4.1,7.566,7.566,0,0,0-1.78-2.66,6.532,6.532,0,0,0-2.42-1.44,8.488,8.488,0,0,0-2.66-.44,7.952,7.952,0,0,0-3.12.66,7.569,7.569,0,0,0-2.92,2.38h-.08V9.2Zm30.12,9a9.17,9.17,0,0,0-3.92.82,9.352,9.352,0,0,0-3,2.18,9.708,9.708,0,0,0-1.92,3.18,10.713,10.713,0,0,0-.68,3.78,11.47,11.47,0,0,0,.74,4.16,10.275,10.275,0,0,0,2.06,3.34,9.255,9.255,0,0,0,3.2,2.22,10.519,10.519,0,0,0,4.16.8,9.349,9.349,0,0,0,5.46-1.66,8.918,8.918,0,0,0,1.8-1.64,10.59,10.59,0,0,0,1.22-1.82h-3.64a6.728,6.728,0,0,1-2.06,1.72,6.1,6.1,0,0,1-2.86.6,6.3,6.3,0,0,1-2.58-.54,7.465,7.465,0,0,1-2.16-1.44,7.026,7.026,0,0,1-1.5-2.08,5.759,5.759,0,0,1-.56-2.5H139.7a3.094,3.094,0,0,0,.06-.52q.02-.36.02-.64a12.169,12.169,0,0,0-.5-3.32,9.519,9.519,0,0,0-1.62-3.22,9.034,9.034,0,0,0-2.94-2.44A9.213,9.213,0,0,0,130.3,18.2Zm0,2.76a5.845,5.845,0,0,1,2.4.48,6.371,6.371,0,0,1,1.88,1.26,6.07,6.07,0,0,1,1.28,1.82,6.869,6.869,0,0,1,.6,2.16H124.1a7.177,7.177,0,0,1,.58-2.12,6.028,6.028,0,0,1,1.26-1.84,6.035,6.035,0,0,1,4.36-1.76Zm13.68-2.12V38h3.16V27.8a7.381,7.381,0,0,1,1.52-5.06,5.249,5.249,0,0,1,4.12-1.7,4.434,4.434,0,0,1,3.58,1.54,6.741,6.741,0,0,1,1.3,4.46V38h3.16V26.84a10.42,10.42,0,0,0-.7-4.08,7.819,7.819,0,0,0-1.78-2.66,6.408,6.408,0,0,0-2.42-1.46,8.488,8.488,0,0,0-2.66-.44,8.1,8.1,0,0,0-3.14.66,7.245,7.245,0,0,0-2.9,2.38h-.08v-2.4Zm31.88,6.28q.68-.68,1.42-1.48a13.417,13.417,0,0,0,1.38-1.78,9.409,9.409,0,0,0,1.04-2.18,8.308,8.308,0,0,0,.4-2.64,7.458,7.458,0,0,0-.5-2.7,6.678,6.678,0,0,0-1.48-2.3,7.115,7.115,0,0,0-2.48-1.6,9.386,9.386,0,0,0-3.5-.6,8.854,8.854,0,0,0-3.16.56,7.819,7.819,0,0,0-2.58,1.58,7.421,7.421,0,0,0-1.74,2.46,8.17,8.17,0,0,0-.68,3.16h3.48a5.4,5.4,0,0,1,.36-2.02,4.46,4.46,0,0,1,.98-1.52,4.111,4.111,0,0,1,1.46-.94,4.9,4.9,0,0,1,1.76-.32,5.093,5.093,0,0,1,1.98.36,4.328,4.328,0,0,1,1.46.98,4.045,4.045,0,0,1,.9,1.44,5.143,5.143,0,0,1,.3,1.78,4.784,4.784,0,0,1-.28,1.7,6.753,6.753,0,0,1-.78,1.46,12.591,12.591,0,0,1-1.2,1.46q-.7.74-1.54,1.7a9.409,9.409,0,0,0-1.16,1.56,7.439,7.439,0,0,0-.68,1.54,8.159,8.159,0,0,0-.32,1.68q-.08.9-.08,1.98h2.92a9.141,9.141,0,0,1,.12-1.54,5.757,5.757,0,0,1,.4-1.34,5.985,5.985,0,0,1,.72-1.22A12.058,12.058,0,0,1,175.861,25.12Zm-5.56,9.36V38h3.52V34.48Z",
    transform: "translate(0 15.082)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_764",
    "data-name": "Grupo 764",
    transform: "translate(1057.886 4383.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_762",
    "data-name": "Grupo 762",
    transform: "translate(211.289 320.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_761",
    "data-name": "Grupo 761",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_715",
    "data-name": "Trazado 715",
    d: "M278.587,320.15,237.552,537.636H398.957l8.207-325.545c-32.828-23.253-77.967,0-101.22,24.621-22.258,23.567-8.768,52.433-9.459,69.261-.315,7.687-17.9,14.177-17.9,14.177",
    transform: "translate(-218.605 -303.73)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_716",
    "data-name": "Trazado 716",
    d: "M311.365,394.739a22.223,22.223,0,1,1-5.006-40.26",
    transform: "translate(-229.762 -345.797)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_717",
    "data-name": "Trazado 717",
    d: "M296.448,390.2l17.454-9.825-16.575-3.937",
    transform: "translate(-235.011 -352.184)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_718",
    "data-name": "Trazado 718",
    d: "M323.82,595.4l162.089-.187c128.577-17.782,73.863-186.026,73.863-186.026L373.634,442.3Z",
    transform: "translate(-242.636 -361.308)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_84",
    "data-name": "Elipse 84",
    cx: 119.344,
    cy: 119.344,
    r: 119.344,
    transform: "translate(72.977 -83.774)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_719",
    "data-name": "Trazado 719",
    d: "M644.645,409.054s44.849,47.288,24.332,122.518",
    transform: "translate(-332.007 -361.27)",
    fill: "none",
    stroke: "#fd0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_720",
    "data-name": "Trazado 720",
    d: "M327.612,303.894s21.885-27.357,57.449-17.782",
    transform: "translate(-243.692 -326.457)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 26
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_721",
    "data-name": "Trazado 721",
    d: "M504.775,292.282s34.961-20.653,65.054,13.543",
    transform: "translate(-293.044 -327.02)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 26
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_723",
    "data-name": "Trazado 723",
    d: "M631.767,359.257a22.223,22.223,0,1,1,5.006,40.26",
    transform: "translate(-328.419 -346.501)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_724",
    "data-name": "Trazado 724",
    d: "M652.98,375.651l-17.454,9.825,16.575,3.938",
    transform: "translate(-329.466 -351.965)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_132",
    "data-name": "L\\xEDnea 132",
    x1: 6.393,
    y2: 97.392,
    transform: "translate(167.462 -31.057)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_85",
    "data-name": "Elipse 85",
    cx: 114.096,
    cy: 12.82,
    rx: 114.096,
    ry: 12.82,
    transform: "translate(289.489 308.071)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_763",
    "data-name": "Grupo 763",
    transform: "translate(256.641 264.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_725",
    "data-name": "Trazado 725",
    d: "M425.638,300.111c-.308,27.743,7.02,41.643,18.626,51.093,20.8,16.937,51.08,14.556,70.04-4.42,29.236-29.261,24.219-79.2,24.219-79.2-39.031-9.184-83.8,2.678-83.8,2.678l-29.456,26.5a4.079,4.079,0,0,1-2.728,1.047H390.461a4.082,4.082,0,0,1-2.729-1.047l-29.449-26.5s-44.771-11.862-83.8-2.678c0,0-5.018,49.938,24.219,79.2,18.96,18.977,49.239,21.357,70.04,4.42,11.606-9.451,18.934-23.351,18.625-51.093",
    transform: "translate(-274.153 -264.099)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsking);
export default __webpack_public_path__ + "static/media/asking.cbba46527744c3851c0278598d2722fe.svg";
export { ForwardRef as ReactComponent };